import styled from '@emotion/styled';
import { Fade } from 'react-awesome-reveal';
import { CUSTOM_BREAK_POINT } from '../Block.styled';

type Props = {};

const GrowUpDetail = (props: Props) => {
  return (
    <DetailWrapper>
      <Fade cascade damping={0.3} direction='up' triggerOnce>
        <Title>어른이 된 꺼미</Title>
        <Description>
          <Statement>
            GOLD를 달성한 홀더만이 2단계 프로젝트에 참여가능합니다.
          </Statement>
          <Statement>
            파츠 NFT를 장착하여 해당 파츠계열사 혜택을 누리세요!
          </Statement>
          <Statement>
            파츠 NFT는 총 6개까지 장착할 수 있으며 2개의 등급으로
          </Statement>
          <Statement>
            구분됩니다. PRESTIGE 등급을 뽑는 행운이 당신에게 함께하길!
          </Statement>
          <Remark>
            (파츠별 혜택은 제공 계열사에 따라 상이하며, 장착 시 6개월 내 해제
            불가)
          </Remark>
        </Description>
      </Fade>
    </DetailWrapper>
  );
};

const DetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
  width: 550px;
  height: 500px;
`;

const Title = styled.h2`
  font-size: 40px;
  font-weight: 600;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    text-align: center;
  }
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    text-align: center;
  }
`;

const Statement = styled.p`
  font-size: 20px;
  line-height: 150%;
`;

const Remark = styled.p`
  font-size: 18px;
  line-height: 200%;
`;

export default GrowUpDetail;
